<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="author">THOMAS FISCHER</p>
<div class="img_containerf"><img alt="image" src="images/f000i-01.jpg"/></div>
<h1 class="title">ARMY</h1>
<h1 class="titlea"><img alt="image" src="images/f000i-02.jpg"/> <span class="middle">OF THE</span> <img alt="image" src="images/f000i-02.jpg"/></h1>
<h1 class="titleb">ROMAN</h1>
<h1 class="titlec">EMPERORS</h1>
<div class="img_containerf"><img alt="image" src="images/f000i-01.jpg"/></div>
<p class="author1"><em class="italic">With contributions by</em></p>
<p class="author2">Ronald Bockius, Dietrich Boschung, and Thomas Schmidts</p>
<p class="author1"><em class="italic">Translated by</em></p>
<p class="author2">M. C. Bishop</p>
<div class="pub"><img alt="images" src="images/f000i-03.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?cc57bc24